import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';

export default {
  fetch() {
    Dispatcher.dispatch({
      actionType: ActionTypes.PRODUCT_FOCUSES_FETCH,
    });
  },
  fetchById(id){
    Dispatcher.dispatch({
      actionType: ActionTypes.PRODUCT_FOCUS_FETCH_BY_ID,
      id: id,
    })
  },
  viewContent(asset){
    Dispatcher.dispatch({
      actionType: ActionTypes.PRODUCT_FOCUS_GROUP_CONTENT_VIEWED,
      id: asset.id,
      groupId: asset.groupId,
    });
  },
  viewProductFocus(id){
    Dispatcher.dispatch({
      actionType: ActionTypes.PRODUCT_FOCUS_VIEWED,
      id: id,
    });
  }
}
